import React from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'

const ButtonMenu = ({ className, onClick, menuActive }) => {
    
    const buttonClasses = classnames({
        'button': true,
        [styles['button-menu']]: true,
        [styles['button-menu--active']]: menuActive,
        [className]: true
    })

    return (
        <button className={buttonClasses} onClick={onClick}>
            <span className={styles['button-menu__line']} />
            <span className={styles['button-menu__line']} />
            <span className={styles['button-menu__line']} />
        </button>
    )
}

export default ButtonMenu
